const Pdata=[
    {
    "id": 1,
    "title": "Switzerland",
    "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2019/07/flag-3.png",
    
    },
    {
    "id": 2,
    "title": "Africa",
    "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2019/07/flag-4.png",
    
    },
    {
        "id": 3,
        "title": "Australia",
        "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2019/07/flag-2.png",
        
        },
        {
            "id": 4,
            "title": "Canada",
            "image": "https://demo.themexpert.com/wordpress/valley/tour-classic/wp-content/uploads/sites/5/2019/07/flag-1.png",
            
            },
]
export default Pdata







